import React, { Component } from 'react';
import { View, Text, Button, FlatList, StyleSheet, ActivityIndicator, TouchableOpacity, TextInput } from 'react-native';
import { Link } from 'react-router-dom';
import AuthContainer from '../../components/AuthContainer';
import firebase, { storageRef, db } from '../../configs/firebase';
import './AllPosters.css';

const IMAGE_FOLDER_NAME = 'posters';
const POSTER_COLLECTION_FOLDER_NAME = 'fpAppContent';
const collectionRef = db.collection(POSTER_COLLECTION_FOLDER_NAME);

export default class AllPosters extends Component {

    constructor() {
        super();
        this.state = {
            showContentModal: false,
            posters: null,
            modalPoster: null,
            loader: false
        }
    }

    componentDidMount() {
        collectionRef.orderBy("time", "desc").limit(15)
            .get()
            .then((querySnapshot) => {
                let posters = [];

                querySnapshot.forEach(function (doc) {
                    // doc.data() is never undefined for query doc snapshots
                    posters.push(doc.data());
                    console.log(doc.id, " => ", doc.data());
                });

                this.setState({
                    posters
                })
            })
            .catch(function (error) {
                console.log("Error getting documents: ", error);
                alert("Unable to fetch data");
            });
    }

    _renderList() {
        return (
            <View>
                <View style={{ flexDirection: 'row', justifyContent: 'space-around', alignItems: 'center' }}>
                    <Text style={styles.displayHeadings}>Title</Text>
                    <Text style={styles.displayHeadings}>Date</Text>
                    <Text style={styles.displayHeadings}>Actions</Text>
                </View>
                <hr width="100%" />
                <FlatList
                    data={this.state.posters}
                    renderItem={({ item }) => this._renderItem(item)}
                />
            </View>

        );
    }

    _renderItem(item) {
        return (
            <View style={{ flexDirection: 'row', borderBottomWidth: 1, marginBottom: 10, justifyContent: 'space-around', alignItems: 'center', width: '100%' }} key={item.id}>
                <Text style={styles.displayLabel}>{item.title.substr(0, 30)}</Text>
                <Text style={styles.displayLabel}>{String(item.time.toDate()).substr(0, 33)}</Text>
                <View style={{ flexDirection: 'row' }}>
                    <Button title="View" color='green' onPress={() => {
                        this.setState({ modalPoster: item }, () => this._showModal())
                    }} />
                    <Link to={'/posters/edit/' + item.id} > <Button title="Edit" color='blue' /></Link>
                    <Button title="Delete" color='red' onPress={() => this._deletePoster(item)} />
                </View>
            </View>
        );
    }

    _deletePoster(item) {
        if (
            window.confirm(
                'Are you sure you want to delete' + ' "' +
                item.title + '" ' +
                //'\nPublished on', item.time.toDate() + ' ' +
                '?'
            )
        ) {

            this.setState({ loader: true })

            collectionRef.doc(item.id).delete().then(() => {
                console.log("Document successfully deleted!");

                // Create a reference to the file to delete
                console.log('Img URL', item.imgUrl);
                const filename = String(item.imgUrl).match(/2F(.*?((jpeg)|(jpg)))/)[1];
                alert('deleting ' + filename);

                const imageRef = storageRef.child(IMAGE_FOLDER_NAME + '/' + filename);

                // Delete the file
                imageRef.delete().then(() => {
                    // File deleted successfully
                    console.log('Deleted the image file');
                    this.setState({ loader: false })
                    alert('Successfully deleted!');
                    this._refresh();
                }).catch((error) => {
                    // Uh-oh, an error occurred!
                    console.log(error);
                    this.setState({ loader: false })
                    alert('Deleted poster, but couldn\'t delete image file.');
                    this._refresh();
                });
            }).catch((error) => {
                this.setState({ loader: false })
                console.error("Error removing document: ", error);
                alert('Some error occured while deleting');
            });
        }
    }

    _refresh() {
        window.location.reload();
    }

    _getFileName(item) {
        alert(String(item.imgUrl).match(/\d+([Aa-zZ])\w+(.jpeg)+/g));
    }


    _showModal = () => {
        this.setState({ showContentModal: true });
    }

    _hideModal = () => {
        this.setState({ showContentModal: false });
    }

    _renderModalContent() {
        const poster = this.state.modalPoster;
        return (
            <View style={{ flexDirection: 'column', justifyContent: 'center', alignItems: 'flex-start' }}>
                <Text style={styles.modalValues}>{poster.title}</Text>
                <img src={poster.imgUrl} height="120" width="120" alt={poster.title} />
                <View style={{ flexDirection: 'column', justifyContent: 'center' }}>
                    <Text style={styles.modalTitle}>Published on: </Text><br />
                    <Text style={styles.modalValues}>{String(poster.time.toDate())}</Text>
                </View>
                <View>
                    <Text style={styles.modalTitle}>Image URL:</Text>
                    <TextInput value={poster.imgUrl} editable={false} style={styles.modalInputBox} />
                </View>
                <View>
                    <Text style={styles.modalTitle}>External URL:</Text>
                    <TextInput value={poster.infoUrl} editable={false} style={styles.modalInputBox} />
                </View>
                <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                    <Text style={styles.modalTitle}>Description: </Text>
                    <TextInput value={poster.description} editable={false} style={styles.modalInputBox} />
                </View>
                <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                    <Text style={styles.modalTitle}>Category ID: </Text>
                    <Text style={styles.modalValues}>{poster.categoryId}</Text>
                </View>
                <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                    <Text style={styles.modalTitle}>Content Type: </Text>
                    <Text style={styles.modalValues}>{poster.contentType}</Text>
                </View>
                <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                    <Text style={styles.modalTitle}>ID: </Text>
                    <Text style={styles.modalValues}>{poster.id}</Text>
                </View>

            </View>
        )
    }

    render() {
        return (
            <AuthContainer>
                <View style={{ padding: '5%', alignItems: 'center' }}>
                    <Text style={styles.title}>All posters</Text>
                    {this.state.loader || !this.state.posters ? <ActivityIndicator size="large" color="#0000ff" /> : null}
                    <View style={{ width: '80%' }}>
                        {this.state.posters && this.state.posters.length > 0 && this._renderList()}
                    </View>

                    <Modal show={this.state.showContentModal} handleClose={this._hideModal} >
                        <View style={{ flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                            {this.state.modalPoster && this._renderModalContent()}
                        </View>
                    </Modal>
                </View>
            </AuthContainer>
        )
    }
}

const Modal = ({ handleClose, show, children }) => {
    const showHideClassName = show ? "modal display-block" : "modal display-none";

    return (
        <div className={showHideClassName}>
            <section className="modal-main">
                {children}
                <Button title="Close" onPress={handleClose} />
            </section>
        </div>
    );
};


const styles = StyleSheet.create({
    uploadInputbox: {
        borderBottomColor: '#5a80f8',
        borderBottomWidth: 2,
        fontSize: 20,
        marginBottom: 10
    },
    uploadPicker: {
        height: 30,
        marginBottom: 10
    },
    displayLabel: {
        fontSize: 15
    },
    displayHeadings: {
        fontSize: 16,
        color: '#a1a6a9'
    },
    title: {
        fontSize: 28,
        marginBottom: 10
    },
    greyText: {
        color: '#a1a6a9',
        maxWidth: '100%'
    },
    modalTitle: {
        fontSize: 17,
        color: '#a1a6a9'
    },
    modalValues: {
        fontSize: 16
    },
    modalInputBox: {
        borderBottomColor: '#5a80f8',
        borderBottomWidth: 1,
        fontSize: 16,
    }
})